// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './project/context/AuthContext';

import Dashboard from './project/pages/Dashboard';
import NotFoundPage from './project/pages/NotFoundPage';
import Entity from './pages/Entity';
import Auth from './project/pages/Activity/Auth';
import Activity from './project/pages/Activity';
import AuthorizedActivity from './project/pages/Activity/Authorized';
import Module from './pages/Module';

import EntryRequest from './pages/Activity/Component/EntryRequest';
import EntryActionCompnent from './pages/Activity/Component/EntryActionComponent';
import EntryEntity from './pages/Entity/Entry';
import EntryModule from './pages/Module/Entry';
import User from './core/user';
import EntryUser from './core/user/Entry';
import Shift from './core/attendance/shift';
import EntryShift from './core/attendance/shift/Entry';
import CoreEntrySchedule from './core/attendance/schedule/Entry';
import './App.css';
import CoreEmployee from './core/attendance/employee';
import EntryEmployee from './core/attendance/employee/Entry';
import EntryOvertime from './core/attendance/overtime/Entry';
import Attendance from './core/attendance/attendance';
import Salary from './core/attendance/salary';
import BaseProduct from './pages/Base/Product';
import BaseEntryProduct from './pages/Base/Product/Entry';
import Sale from './pages/Base/Transaction';
import History from './pages/Base/History';
import Project from './core/project';
import Home from './website/Home';
// import Home from './website-project/Home'; //AKTIFKAN KEJATI, RENTCAR
import Outlet from './core/subproject';
import EntryProject from './core/project/Entry';
import EntryOutlet from './core/subproject/Entry';
import Menu from './pages/Menu';
import EntryMenu from './pages/Menu/Entry';
import EntryAccess from './pages/Access/Entry';
import Service from './website/Service';
import Catalog from './website/Catalog';
import Company from './website/Company';
import Procedure from './pages/Procedure';
import EntryProcedure from './pages/Procedure/Entry';
import SortData from './pages/SortData';
import ProtectedRoute from './project/component/ProtectedRoute';
import PublicRoute from './project/component/PublicRoute';
import EntryLayoutCompnent from './pages/Activity/Component/EntryLayoutComponent';
import PrintThermal from './project/pages/Activity/Print/Thermal';

import AwardsPage from './website/Awards';
import MKiosKejati from './project/pages/Kejati/mkios';
import Queue from './project/pages/Kejati/mkios/Queue';
import Reservation from './project/pages/Kejati/mkios/Reservation';
import Signature from './project/pages/Kejati/component/Signature';
import './App.css';
import HelloWorld from './project/pages/StudyAbroad/public';
import Universities from './project/pages/StudyAbroad/public/universities';
import University from './project/pages/StudyAbroad/public/universities/University';
import HelloKejati from './project/pages/Kejati/public';
import Account from './project/pages/ERPPPSU/dashboard/Account/Account';
import EntryAccount from './project/pages/ERPPPSU/dashboard/Account/EntryAccount';
import CashBank from './project/pages/ERPPPSU/dashboard/CashBank/CashBank';
import Product from './project/pages/ERPPPSU/dashboard/Product/Product';
import EntryProduct from './project/pages/ERPPPSU/dashboard/Product/EntryProduct';
import Contact from './project/pages/ERPPPSU/dashboard/Contact/Contact';
import EntryContact from './project/pages/ERPPPSU/dashboard/Contact/EntryContact';
import Sales from './project/pages/ERPPPSU/dashboard/Sales/Sales';
import EntrySales from './project/pages/ERPPPSU/dashboard/Sales/EntrySales';
import DetailSales from './project/pages/ERPPPSU/dashboard/Sales/DetailSales';
import Purchases from './project/pages/ERPPPSU/dashboard/Purchases/Purchases';
import DetailPurchases from './project/pages/ERPPPSU/dashboard/Purchases/DetailPurchases';
import EntryPurchases from './project/pages/ERPPPSU/dashboard/Purchases/EntryPurchases';
import DetailCashBank from './project/pages/ERPPPSU/dashboard/CashBank/DetailCashBank';
import TransactionCashBank from './project/pages/ERPPPSU/dashboard/CashBank/TransactionCashBank';
import DetailReservation from './project/pages/Kejati/dashboard/Reservation/DetailReservation';
import EntryReservation from './project/pages/Kejati/public/EntryReservation/EntryReservation';
import TransferCashBank from './project/pages/ERPPPSU/dashboard/CashBank/TransferCashBank';
import Expenses from './project/pages/ERPPPSU/dashboard/Expenses/Expenses';
import EntryExpenses from './project/pages/ERPPPSU/dashboard/Expenses/EntryExpenses';
import DetailEmployee from './project/pages/HRPPSU/dashboard/Employee/DetailEmployee';
import Schedule from './project/pages/HRPPSU/dashboard/TimeManagement/Schedule/Schedule';
import EntrySchedule from './project/pages/HRPPSU/dashboard/TimeManagement/Schedule/EntrySchedule';
import HistoryTransfer from './project/pages/ERPPPSU/dashboard/CashBank/History/HistoryTransfer';
import Employee from './project/pages/HRPPSU/dashboard/Employee/Employee';
import HistoryBankDeposit from './project/pages/ERPPPSU/dashboard/CashBank/History/HistoryBankDeposit';
import HistoryBanWithdrawal from './project/pages/ERPPPSU/dashboard/CashBank/History/HistoryBankWithdrawal';
import DetailProduct from './project/pages/ERPPPSU/dashboard/Product/DetailProduct';
import HistoryReservation from './project/pages/Kejati/dashboard/Reservation/HistoryReservation';
import DashboardKejati from './project/pages/Kejati/dashboard/DashboardKejati';
import DetailFileReception from './project/pages/Kejati/dashboard/FileReception/DetailFileReception';
import News from './project/pages/Kejati/public/News/News';
import EntrySalesPayment from './project/pages/ERPPPSU/dashboard/Sales/EntrySalesPayment';
import EntryPurchasesPayment from './project/pages/ERPPPSU/dashboard/Purchases/EntryPurchasesPayment';
import DetailExpenses from './project/pages/ERPPPSU/dashboard/Expenses/DetailExpenses';
import EntryExpensesPayment from './project/pages/ERPPPSU/dashboard/Expenses/EntryExpensesPayment';
import Report from './project/pages/ERPPPSU/dashboard/Report/Report';
import ManageNews from './project/pages/Kejati/dashboard/News/News';
import DetailNews from './project/pages/Kejati/dashboard/News/DetailNews';
import EditNews from './project/pages/Kejati/dashboard/News/EditNews';
import HistoryFileReception from './project/pages/Kejati/dashboard/FileReception/HistoryFileReception';
import ReportProfitLossBudget from './project/pages/ERPPPSU/dashboard/Report/ReportProfitLossBudget';
import ReportBalanceSheet from './project/pages/ERPPPSU/dashboard/Report/ReportBalanceSheet';
import ReportCashFlow from './project/pages/ERPPPSU/dashboard/Report/ReportCashFlow';
import ReadNews from './project/pages/Kejati/public/News/ReadNews';
import ReportSales from './project/pages/ERPPPSU/dashboard/Report/ReportSales';
import ReportPurchases from './project/pages/ERPPPSU/dashboard/Report/ReportPurchases';
import ReportCustomerBalance from './project/pages/ERPPPSU/dashboard/Report/ReportCustomerBalance';
import ReportVendorBalance from './project/pages/ERPPPSU/dashboard/Report/ReportVendorBalance';
import BudgetManagement from './project/pages/ERPPPSU/dashboard/BudgetManagement/BudgetManagement';
import EntryBudgetManagement from './project/pages/ERPPPSU/dashboard/BudgetManagement/EntryBudgetManagement';
import Ocr from './project/pages/Activity/Ocr';
import KejatiHome from './project/pages/Kejati/public/Home/Home';
import EntryNews from './project/pages/Kejati/dashboard/News/EntryNews';
import QRCodeScanner from './project/pages/Kejati/mkios/QRCodeScanner';
import EntryFileReception from './project/pages/Kejati/dashboard/FileReception/EntryFileReception';
import ReportProfitLoss from './project/pages/ERPPPSU/dashboard/Report/ReportProfitLoss';
import ReportStatementEquity from './project/pages/ERPPPSU/dashboard/Report/ReportStatementEquity';
import ReportGeneralLedger from './project/pages/ERPPPSU/dashboard/Report/ReportGeneralLedger';
import ReportJournal from './project/pages/ERPPPSU/dashboard/Report/ReportJournal';
import ReportBussiness from './project/pages/ERPPPSU/dashboard/Report/ReportBussiness';
import Facilites from './project/pages/STAYNEST/dashboard/Facilities/Facilites';
import Rooms from './project/pages/STAYNEST/dashboard/Rooms/Rooms';
import EntryRoom from './project/pages/STAYNEST/dashboard/Rooms/EntryRoom';
import EntryJournal from './project/pages/ERPPPSU/dashboard/Journal/EntryJournal';
import Reservations from './project/pages/STAYNEST/dashboard/Reservations/Reservations';
import HomePage from './project/pages/STAYNEST/public';
import HotelDetail from './project/pages/STAYNEST/public/DetailHotel';
import DashboardStayNest from './project/pages/STAYNEST/dashboard';
import DetailJournal from './project/pages/ERPPPSU/dashboard/Journal/DetailJournal';
import ImportExport from './project/pages/ERPPPSU/dashboard/ImportExport';
import EntryAsset from './project/pages/ERPPPSU/dashboard/Assets/EntryAsset';
import Assets from './project/pages/ERPPPSU/dashboard/Assets/Assets';
import RentCar from './project/pages/RentCar/public';
import ManagePrices from './project/pages/RentCar/dashboard/Prices/Prices';
import ManageUnits from './project/pages/RentCar/dashboard/Units/Units';
import EntryUnit from './project/pages/RentCar/dashboard/Units/EntryUnit';
import EntryPrice from './project/pages/RentCar/dashboard/Prices/EntryPrice';
import EntryCompany from './project/pages/RentCar/dashboard/Company/EntryCompany';
import Presentation from './website/Presentation';
import FormRequestApp from './website/FormRequestApp';
import PartnerGrid from './website/Partner';
import MerchantB2B from './website/Merchant';
import ClientB2B from './website/Client';
import HelloLPay from './project/pages/LPay';

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>

                    {/* START PAKSONG RENT CAR */}
                        <Route path="/landing-page" element={<RentCar />} />
                        <Route path='/activity-rentcar/company' element={<ProtectedRoute element={EntryCompany} />} />
                        <Route path='/activity-rentcar/manage-units' element={<ProtectedRoute element={ManageUnits} />} />
                        <Route path='/activity-rentcar/entry-unit' element={<ProtectedRoute element={EntryUnit} />} />
                        <Route path="/activity-rentcar/entry-unit/:id" element={<ProtectedRoute element={EntryUnit} />} />
                        <Route path='/activity-rentcar/manage-prices' element={<ProtectedRoute element={ManagePrices} />} />
                        <Route path='/activity-rentcar/entry-price' element={<ProtectedRoute element={EntryPrice} />} />
                        <Route path='/activity-rentcar/entry-price/:id' element={<ProtectedRoute element={EntryPrice} />} />
                        
                    {/* END PAKSONG RENT CAR */}

                    <Route path="/print-thermal" element={<PrintThermal />} />
                    <Route path="/public/:link/:params?" element={<Activity />} />
                    <Route path="/activity/auth" element={<ProtectedRoute element={Auth} />} />
                    <Route path="/activity/:link/:params?" element={<ProtectedRoute element={AuthorizedActivity} />} />

                    <Route path='/sort-data' element={<SortData />} />

                    {/* <Route exact path="/" element={<PublicRoute element={Home} />} /> */}
                    <Route exact path="/" element={<PublicRoute element={HelloLPay} />} />
                    {/* <Route exact path="/" element={<Presentation/>} /> */}
                    
                    <Route path="/service" element={<PublicRoute element={Service} />} />
                    <Route path="/catalog" element={<PublicRoute element={Catalog} />} />
                    <Route path="/about/company" element={<PublicRoute element={Company} />} />
                    <Route path="/about/partnership" element={<PublicRoute element={PartnerGrid} />} />
                    <Route path="/about/client" element={<PublicRoute element={ClientB2B} />} />
                    <Route path="/about/merchant" element={<PublicRoute element={MerchantB2B} />} />
                    
                    
                    <Route path="/request-app" element={<PublicRoute element={FormRequestApp} />} />
                                    
                    <Route path="/admin-login" element={<Auth />} />

                    <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
                    <Route path="/entity" element={<ProtectedRoute element={Entity} />} />
                    <Route path="/add-entity" element={<ProtectedRoute element={EntryEntity} />} />
                    <Route path="/edit-entity/:id" element={<ProtectedRoute element={EntryEntity} />} />

                    <Route path="/procedure" element={<ProtectedRoute element={Procedure} />} />
                    <Route path="/add-procedure" element={<ProtectedRoute element={EntryProcedure} />} />
                    <Route path="/edit-procedure/:id" element={<ProtectedRoute element={EntryProcedure} />} />

                    <Route path="/menu" element={<ProtectedRoute element={Menu} />} />
                    <Route path="/add-menu" element={<ProtectedRoute element={EntryMenu} />} />
                    <Route path="/edit-menu/:id" element={<ProtectedRoute element={EntryMenu} />} />

                    <Route path="/module" element={<ProtectedRoute element={Module} />} />
                    <Route path="/add-module" element={<ProtectedRoute element={EntryModule} />} />
                    <Route path="/edit-module/:id" element={<ProtectedRoute element={EntryModule} />} />

                    <Route path="/activity-request/:action/:id_module_action" element={<ProtectedRoute element={EntryRequest} />} />
                    <Route path="/edit-activity-request/:action/:id_module_action/:id" element={<ProtectedRoute element={EntryRequest} />} />

                    <Route path="/activity-component/:id_module/:id_parent" element={<ProtectedRoute element={EntryActionCompnent} />} />
                    <Route path="/edit-activity-component/:id_module/:id_parent/:id" element={<ProtectedRoute element={EntryActionCompnent} />} />

                    <Route path="/edit-activity-layout/:id_module/:id_parent/:id" element={<ProtectedRoute element={EntryLayoutCompnent} />} />

                    {/* CORE */}
                    <Route path="/project" element={<ProtectedRoute element={Project} />} />
                    <Route path="/add-project" element={<ProtectedRoute element={EntryProject} />} />
                    <Route path="/edit-project/:id" element={<ProtectedRoute element={EntryProject} />} />

                    <Route path="/subproject/:project" element={<ProtectedRoute element={Outlet} />} />
                    <Route path="/add-subproject/:project" element={<ProtectedRoute element={EntryOutlet} />} />
                    <Route path="/edit-subproject/:project/:id" element={<ProtectedRoute element={EntryOutlet} />} />

                    <Route path="/users" element={<ProtectedRoute element={User} />} />
                    <Route path="/add-user" element={<ProtectedRoute element={EntryUser} />} />
                    <Route path="/edit-user/:id" element={<ProtectedRoute element={EntryUser} />} />

                    <Route path="/access-menu" element={<ProtectedRoute element={EntryAccess} />} />

                    <Route path="/employee" element={<ProtectedRoute element={CoreEmployee} />} />
                    <Route path="/add-employee" element={<ProtectedRoute element={EntryEmployee} />} />
                    <Route path="/edit-employee/:id" element={<ProtectedRoute element={EntryEmployee} />} />

                    <Route path="/attendance-shift" element={<ProtectedRoute element={Shift} />} />
                    <Route path="/add-attendance-shift" element={<ProtectedRoute element={EntryShift} />} />
                    <Route path="/edit-attendance-shift/:id" element={<ProtectedRoute element={EntryShift} />} />

                    <Route path="/attendance-schedule/:id_hs_employee" element={<ProtectedRoute element={CoreEntrySchedule} />} />
                    <Route path="/attendance/:id_hs_employee" element={<ProtectedRoute element={Attendance} />} />

                    <Route path="/salary" element={<ProtectedRoute element={Salary} />} />

                    <Route path="/attendance-overtime" element={<ProtectedRoute element={Employee} />} />
                    <Route path="/add-attendance-overtime/:id_attendance" element={<ProtectedRoute element={EntryOvertime} />} />
                    <Route path="/edit-attendance-overtime/:id_attendance/:id" element={<ProtectedRoute element={EntryOvertime} />} />

                    {/* START SUPERAPP */}
                    <Route path="/activity-super/awards-applaunch" element={<ProtectedRoute element={AwardsPage} />} />
                    {/* END SUPERAPP */}

                    {/* START KEJATI */}
                    <Route path="/morning" element={<HelloKejati />} />
                    <Route path="/mkios/:uker?" element={<MKiosKejati />} />
                    <Route path="/mkios-new-queue/:uker?" element={<Queue service="Pengantaran Berkas" />} />
                    <Route path="/mkios-new-queue-online/:uker?" element={<Queue service="Pengantaran Pesanan Online" />} />
                    <Route path="/mkios-new-queue-taking-goods/:uker/:code" element={<Queue service="Pengambilan Barang" />} />
                    <Route path="/mkios-reservation-checking/:uker?" element={<Reservation />} />
                    <Route path="/activity-kejati/home" element={<KejatiHome />} />
                    <Route path="/activity-kejati/news" element={<News />} />
                    <Route path="/activity-kejati/news/detail/:id" element={<ReadNews />} />

                    <Route path='/activity-kejati/dashboard' element={<ProtectedRoute element={DashboardKejati} />} />
                    <Route path='/activity-kejati/reservation' element={<ProtectedRoute element={HistoryReservation} />} />
                    <Route path='/activity-kejati/file-reception' element={<ProtectedRoute element={HistoryFileReception} />} />
                    <Route path='/activity-kejati/entry-file-reception/:queue' element={<ProtectedRoute element={EntryFileReception} />} />
                    <Route path='/activity-kejati/reservation/detail/:id' element={<ProtectedRoute element={DetailReservation} />} />
                    <Route path='/activity-kejati/entry-reservation' element={<EntryReservation />} />
                    <Route path='/activity-kejati/detail-file-reception/:id' element={<ProtectedRoute element={DetailFileReception} />} />
                    <Route path='/activity-kejati/manage-news' element={<ProtectedRoute element={ManageNews} />} />                                    
                    <Route path='/activity-kejati/manage-news/detail/:id' element={<ProtectedRoute element={DetailNews} />} />
                    <Route path='/activity-kejati/manage-news/edit/:id' element={<ProtectedRoute element={EntryNews} />} />
                    <Route path='/activity-kejati/manage-news/new' element={<ProtectedRoute element={EntryNews} />} />
                    <Route path='/activity-kejati/scanner' element={<QRCodeScanner />} />

                    {/* END KEJATI */}

                    {/* START ERPPPSU */}
                    <Route path='/activity-erpppsu/accounts' element={<ProtectedRoute element={Account} />} />
                    <Route path='/activity-erpppsu/add-account' element={<ProtectedRoute element={EntryAccount} />} />
                    <Route path='/activity-erpppsu/edit-account/:id' element={<ProtectedRoute element={EntryAccount} />} />

                    <Route path='/activity-erpppsu/cash-bank' element={<ProtectedRoute element={CashBank} />} />
                    <Route path='/activity-erpppsu/cash-bank/detail/:code' element={<ProtectedRoute element={DetailCashBank} />} />
                    <Route path='/activity-erpppsu/cash-bank/transaction/transfer' element={<ProtectedRoute element={TransferCashBank} />} />
                    <Route path='/activity-erpppsu/cash-bank/transaction/:type' element={<ProtectedRoute element={TransactionCashBank} />} />

                    <Route path='/activity-erpppsu/cash-bank/history/transfer/:id' element={<ProtectedRoute element={HistoryTransfer} />} />
                    <Route path='/activity-erpppsu/cash-bank/history/bank-withdrawal/:id' element={<ProtectedRoute element={HistoryBanWithdrawal} />} />
                    <Route path='/activity-erpppsu/cash-bank/history/bank-deposit/:id' element={<ProtectedRoute element={HistoryBankDeposit} />} />

                    <Route path='/activity-erpppsu/product' element={<ProtectedRoute element={Product} />} />
                    <Route path='/activity-erpppsu/product/new' element={<ProtectedRoute element={EntryProduct} />} />
                    <Route path='/activity-erpppsu/edit-product/:id' element={<ProtectedRoute element={EntryProduct} />} />
                    <Route path='/activity-erpppsu/detail-product/:id' element={<ProtectedRoute element={DetailProduct} />} />

                    <Route path='/activity-erpppsu/contact' element={<ProtectedRoute element={Contact} />} />
                    <Route path='/activity-erpppsu/contact/new' element={<ProtectedRoute element={EntryContact} />} />

                    <Route path='/activity-erpppsu/sales' element={<ProtectedRoute element={Sales} />} />
                    <Route path='/activity-erpppsu/sales/detail/:id?' element={<ProtectedRoute element={DetailSales} />} />
                    <Route path='/activity-erpppsu/sales/edit/:id?' element={<ProtectedRoute element={EntrySales} />} />
                    <Route path='/activity-erpppsu/sales/new/:type?' element={<ProtectedRoute element={EntrySales} />} />
                    <Route path='/activity-erpppsu/sales/receive-payment/:customer' element={<ProtectedRoute element={EntrySalesPayment} />} />

                    <Route path='/activity-erpppsu/purchases' element={<ProtectedRoute element={Purchases} />} />
                    <Route path='/activity-erpppsu/purchases/detail/:id?' element={<ProtectedRoute element={DetailPurchases} />} />
                    <Route path='/activity-erpppsu/purchases/edit/:id?' element={<ProtectedRoute element={EntryPurchases} />} />
                    <Route path='/activity-erpppsu/purchases/new/:type?' element={<ProtectedRoute element={EntryPurchases} />} />
                    <Route path='/activity-erpppsu/purchases/make-payment/:supplier' element={<ProtectedRoute element={EntryPurchasesPayment} />} />

                    <Route path='/activity-erpppsu/expenses' element={<ProtectedRoute element={Expenses} />} />
                    <Route path='/activity-erpppsu/expenses/detail/:id?' element={<ProtectedRoute element={DetailExpenses} />} />
                    <Route path='/activity-erpppsu/expenses/edit/:id?' element={<ProtectedRoute element={EntryExpenses} />} />
                    <Route path='/activity-erpppsu/expenses/new' element={<ProtectedRoute element={EntryExpenses} />} />
                    <Route path='/activity-erpppsu/expenses/make-payment/:contact' element={<ProtectedRoute element={EntryExpensesPayment} />} />

                    <Route path='/activity-erpppsu/journal/new' element={<ProtectedRoute element={EntryJournal} />} />
                    <Route path='/activity-erpppsu/journal/detail/:id?' element={<ProtectedRoute element={DetailJournal} />} />
                    <Route path='/activity-erpppsu/journal/edit/:id?' element={<ProtectedRoute element={EntryJournal} />} />

                    <Route path='/activity-erpppsu/asset-management' element={<ProtectedRoute element={Assets} />} />
                    <Route path='/activity-erpppsu/asset-management/new' element={<ProtectedRoute element={EntryAsset} />} />




                    <Route path='/activity-erpppsu/report' element={<ProtectedRoute element={Report} />} />
                    <Route path='/activity-erpppsu/report/general-ledger' element={<ProtectedRoute element={ReportGeneralLedger} />} />
                    <Route path='/activity-erpppsu/report/journal' element={<ProtectedRoute element={ReportJournal} />} />

                    <Route path='/activity-erpppsu/report/profit-loss' element={<ProtectedRoute element={ReportProfitLoss} />} />
                    <Route path='/activity-erpppsu/report/profit-loss-budget' element={<ProtectedRoute element={ReportProfitLossBudget} />} />
                    <Route path='/activity-erpppsu/report/balance-sheet' element={<ProtectedRoute element={ReportBalanceSheet} />} />
                    <Route path='/activity-erpppsu/report/cashflow' element={<ProtectedRoute element={ReportCashFlow} />} />
                    <Route path='/activity-erpppsu/report/sales' element={<ProtectedRoute element={ReportSales} />} />
                    <Route path='/activity-erpppsu/report/statement-equity' element={<ProtectedRoute element={ReportStatementEquity} />} />
                    <Route path='/activity-erpppsu/report/customer-balance' element={<ProtectedRoute element={ReportCustomerBalance} />} />
                    <Route path='/activity-erpppsu/report/purchases' element={<ProtectedRoute element={ReportPurchases} />} />
                    <Route path='/activity-erpppsu/report/vendor-balance' element={<ProtectedRoute element={ReportVendorBalance} />} />
                    <Route path='/activity-erpppsu/report/executive-summary' element={<ProtectedRoute element={ReportBussiness} />} />

                    <Route path='/activity-erpppsu/import-export/:type?' element={<ProtectedRoute element={ImportExport} />} />


                    {/* ?start_period=01/01/2025&templateId=12304&interval=1&no_interval=12 */}
                    <Route path='/activity-erpppsu/budget-management' element={<ProtectedRoute element={BudgetManagement} />} />
                    <Route path='/activity-erpppsu/budget-management/new' element={<ProtectedRoute element={EntryBudgetManagement} />} />
                    <Route path='/activity-erpppsu/budget-management/edit/:id' element={<ProtectedRoute element={EntryBudgetManagement} />} />


                    {/* END ERPPPSU */}

                    {/* START HRPPSU */}
                    <Route path='/activity-hrppsu/employees' element={<ProtectedRoute element={Employee} />} />
                    <Route path='/activity-hrppsu/employee/detail/:id?' element={<ProtectedRoute element={DetailEmployee} />} />
                    <Route path='/activity-hrppsu/time-management/schedule' element={<ProtectedRoute element={Schedule} />} />
                    <Route path='/activity-hrppsu/time-management/entry-schedule/:id_employee?' element={<ProtectedRoute element={EntrySchedule} />} />
                    {/* END HRPPSU */}

                    {/* START STUDY ABROAD */}
                    <Route path="/hello-world" element={<HelloWorld />} />
                    <Route path="/universities" element={<Universities />} />
                    <Route path="/university/:slug" element={<University />} />

                    <Route path="/universities" element={<Universities />} />
                    <Route path="/university/:slug" element={<University />} />
                    {/* END STUDY ABROAD */}

                    {/* START STAY NEST */}

                    <Route path="/activity-staynest/dashboard" element={<ProtectedRoute element={DashboardStayNest} />} />
                    <Route path="/activity-staynest/manage-facilites" element={<ProtectedRoute element={Facilites} />} />
                    <Route path="/activity-staynest/manage-rooms" element={<ProtectedRoute element={Rooms} />} />
                    <Route path="/activity-staynest/reservations" element={<ProtectedRoute element={Reservations} />} />
                    <Route path="/activity-staynest/room/new" element={<ProtectedRoute element={EntryRoom} />} />
                    <Route path="/activity-staynest/room/edit/:id?" element={<ProtectedRoute element={EntryRoom} />} />

                    <Route path="/activity-staynest/home" element={<HomePage />} />
                    <Route path="/activity-staynest/room/detail/:id?/:date?" element={<HotelDetail />} />

                    {/* END STAY NEST */}

                    {/* TEMPLATE */}
                    <Route path="/data-product" element={<ProtectedRoute element={BaseProduct} />} />
                    <Route path="/add-product" element={<ProtectedRoute element={BaseEntryProduct} />} />
                    <Route path="/edit-product/:id" element={<ProtectedRoute element={BaseEntryProduct} />} />

                    <Route path="/sale" element={<ProtectedRoute element={Sale} />} />
                    <Route path="/history" element={<ProtectedRoute element={History} />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;